import styled from "styled-components";

export const FormsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 80%;
  justify-content: center;
  gap: 1rem;
  margin: auto;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const FormSection = styled.section`
  color: #101e8e;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  form {
    margin: auto;
    display: flex;
    flex-direction: column;
    width: 90%;
    align-items: center;
    justify-cotent: center;
    gap: 1rem;
  }
`;

export const FormCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
  justify-content: center;
  box-sizing: border-box;
  @media (width <= 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

export const FormCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 4 2;
  justify-content: space-between;
  background: #fff;
  width: 25%;
  border: 1px solid #101e8e;
  padding: 0.5rem;
  height: 150px;
  p {
    display: flex;
    align-items: center;
    justify-content: space-between;
    svg {
      color: #62aa51;
    }
    @media (width<=880px) {
      font-size: 0.7rem;
    }
  }
  @media (width <= 768px) {
    width: 100%;
  }
`;

export const TrackSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    width: 80%;
    form {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;
    }
  }
`;

export const TrackInput = styled.input`
  width: 80%;
  outline: none;
  padding: 1rem;
  border: none;
  background: #fff;
  border: 1px solid #101e8e;
  color: #101e8e;
`;

export const TrackButton = styled(TrackInput)`
  width: 20%;
  background: #101e8e;
  color: white;
`;

export const FormInput = styled(TrackInput)`
  display:flex;
  background: #fff;
  color: #101e8e;
  width: 45%;
`;

export const FormSelect = styled.select`
  outline: none;
  padding: 1rem;
  border: none;
  background: #fff;
  border: 1px solid #101e8e;
  color: #101e8e;
  background: #fff;
  color: #101e8e;
  width: 45%;
`;
